import { FC, PropsWithChildren } from "react";
import { FlexCenter } from "@/components/ui";
import { useTranslations } from "next-intl";

const HeroTitle: FC<PropsWithChildren> = ({ children }) => {
  const t = useTranslations();

  return (
    <div className="text-xl font-bold sm:text-2xl xl:text-4xl">
      {!children ? (
        <>
          <FlexCenter>
            <h1 className="text-2xl sm:text-4xl">{t("header.title")}</h1>
          </FlexCenter>
          <FlexCenter gap={1} className="m-5 flex-wrap text-sm lg:text-lg">
            <span className="text-secondary-main">{t("services.online")}</span>
            <span>و</span>
            <span className="text-secondary-main">{t("services.instant")}</span>
          </FlexCenter>
        </>
      ) : (
        children
      )}
    </div>
  );
};

export default HeroTitle;
